import L1Img from '../assets/hero-cards/L1.webp';
import L2Img from '../assets/hero-cards/L2.webp';
import L3Img from '../assets/hero-cards/L3.webp';
import L4Img from '../assets/hero-cards/L4.webp';
import L5Img from '../assets/hero-cards/L5.webp';
import L6Img from '../assets/hero-cards/L6.webp';
import L7Img from '../assets/hero-cards/L7.webp';
import L8Img from '../assets/hero-cards/L8.webp';
import L9Img from '../assets/hero-cards/L9.webp';
import L10Img from '../assets/hero-cards/L10.webp';
import L11Img from '../assets/hero-cards/L11.webp';
import L12Img from '../assets/hero-cards/L12.webp';
import L13Img from '../assets/hero-cards/L13.webp';

// Exact 13 verified restitution cases from Hero section in sequential order
export const LIVE_RECOVERIES_DATA = [
  {
    id: '01',
    name: 'Robert H. Miller',
    location: 'Austin, Texas • USA',
    amount: '$184,500',
    image: L1Img,
    status: 'Restitution Approved',
  },
  {
    id: '02',
    name: 'Marcus Vance',
    location: 'Brisbane, Queensland • Australia',
    amount: '$92,400',
    image: L2Img,
    status: 'Claim Documented',
  },
  {
    id: '03',
    name: 'Alastair Sterling',
    location: 'London, Greater London • UK',
    amount: '$245,000',
    image: L3Img,
    status: 'Restitution In Progress',
  },
  {
    id: '04',
    name: 'Chloe Martinez',
    location: 'San Diego, California • USA',
    amount: '$130,000',
    image: L4Img,
    status: 'Recovery Allocated',
  },
  {
    id: '05',
    name: 'Sophie Campbell',
    location: 'Melbourne, Victoria • Australia',
    amount: '$278,000',
    image: L5Img,
    status: 'Forensic Verified',
  },
  {
    id: '06',
    name: 'Gemma Thornton',
    location: 'Manchester, Greater Manchester • UK',
    amount: '$115,200',
    image: L6Img,
    status: 'Asset Traced',
  },
  {
    id: '07',
    name: 'Dr. Lucas Bennett',
    location: 'Denver, Colorado • USA',
    amount: '$198,000',
    image: L7Img,
    status: 'Claim Documented',
  },
  {
    id: '08',
    name: 'Charlotte Hayes',
    location: 'Sydney, New South Wales • Australia',
    amount: '$86,500',
    image: L8Img,
    status: 'Restitution In Progress',
  },
  {
    id: '09',
    name: 'David Kowalski',
    location: 'Chicago, Illinois • USA',
    amount: '$210,000',
    image: L9Img,
    status: 'Claim Documented',
  },
  {
    id: '10',
    name: 'Oliver Wright',
    location: 'Birmingham, West Midlands • UK',
    amount: '$142,800',
    image: L10Img,
    status: 'Claim Documented',
  },
  {
    id: '11',
    name: 'Marcus J. Reynolds',
    location: 'Atlanta, Georgia • USA',
    amount: '$265,000',
    image: L11Img,
    status: 'Claim Verified',
  },
  {
    id: '12',
    name: 'Kwame Adewale',
    location: 'Bristol, South West England • UK',
    amount: '$158,400',
    image: L12Img,
    status: 'Restitution Approved',
  },
  {
    id: '13',
    name: 'Graeme MacIntyre',
    location: 'Perth, Western Australia • Australia',
    amount: '$289,000',
    image: L13Img,
    status: 'Claim Documented',
  },
];
